var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFLogo = function SvgFLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.255 9.425v6.273c.047.66.4.92 1.132.99v.33H0v-.33c.66-.07.99-.33 1.038-.99V2.302C.99 1.642.66 1.382 0 1.312v-.33h9.505L10 3.67l-.307.118c-.519-.944-.99-1.557-2.665-1.627H3.255v6.084h3.372c1.227-.07 1.368-.212 1.887-.849h.212v2.83l-.235.095c-.425-.684-.897-.896-1.887-.896z"
  })));
};
export default SvgFLogo;